import { render, staticRenderFns } from "./article.vue?vue&type=template&id=2b8f99e0&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&id=2b8f99e0&scoped=true&lang=less&"
import style1 from "./article.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f99e0",
  null
  
)

export default component.exports